// account
export const SIGNUP_URL = '/auth/signup';
export const LOGIN_URL = '/auth/login';
export const LOGOUT_URL = '/auth/logout';
export const FORGOT_PASSWORD_URL = '/auth/forgotPassword';
export const RESET_PASSWORD = '/auth/resetPassword';
export const RESET_PASSWORD_AUTHED_URL = '/auth/resetPasswordAuthed';

// fayda
export const FAYDA_AUTH_URL = '/fayda/auth-url';
export const FAYDA_EXCHANGE_URL = '/fayda/exchange';

// organization
export const GET_ORGANIZATION_URL = '/organization';
export const GET_ORGANIZATION_STATS_URL = '/organization/stats';
export const REGISTER_ORGANIZATION_URL = '/organization';
export const SIGNUP_ORGANIZATION_URL = '/organization/signup';
export const EDIT_ORGANIZATION_URL = '/organization';
export const TOGGLE_ORGANIZATION_IS_ACTIVE_URL = '/organization/isActive';
export const DELETE_ORGANIZATION_URL = '/organization';

// employee
export const GET_EMPLOYEE_URL = '/employee';
export const GET_EMPLOYEE_STATS_URL = '/employee/stats';
export const GET_EMPLOYEE_DIRECTORY_URL = '/employee/directory';
export const GET_EMPLOYEE_ACTIVITY_URL = '/employee';
export const REGISTER_EMPLOYEE_URL = '/employee';
export const EDIT_EMPLOYEE_URL = '/employee';
export const UPLOAD_EMPLOYEE_PROFILE_PHOTO_URL = '/employee';
export const INVITE_EMPLOYEE_URL = '/employee/invite';
export const TOGGLE_EMPLOYEE_IS_ACTIVE_URL = '/employee/isActive';
export const DELETE_EMPLOYEE_URL = '/employee';

// employee_address
export const GET_EMPLOYEE_ADDRESS_URL = '/employeeAddress';
export const REGISTER_EMPLOYEE_ADDRESS_URL = '/employeeAddress';
export const EDIT_EMPLOYEE_ADDRESS_URL = '/employeeAddress';
export const TOGGLE_EMPLOYEE_ADDRESS_IS_ACTIVE_URL = '/employeeAddress/isActive';
export const DELETE_EMPLOYEE_ADDRESS_URL = '/employeeAddress';

// employee_position
export const GET_EMPLOYEE_POSITION_URL = '/employeePosition';
export const REGISTER_EMPLOYEE_POSITION_URL = '/employeePosition';
export const EDIT_EMPLOYEE_POSITION_URL = '/employeePosition';
export const TOGGLE_EMPLOYEE_POSITION_IS_ACTIVE_URL = '/employeePosition/isActive';
export const DELETE_EMPLOYEE_POSITION_URL = '/employeePosition';
export const GET_UNASSIGNED_EMPLOYEES_URL = '/employeePosition/unassigned';

// employee_salary
export const GET_EMPLOYEE_SALARY_URL = '/employeeSalary';
export const REGISTER_EMPLOYEE_SALARY_URL = '/employeeSalary';
export const EDIT_EMPLOYEE_SALARY_URL = '/employeeSalary';
export const TOGGLE_EMPLOYEE_SALARY_IS_ACTIVE_URL = '/employeeSalary/isActive';
export const DELETE_EMPLOYEE_SALARY_URL = '/employeeSalary';

// employee_salary_promotion
export const GET_EMPLOYEE_SALARY_PROMOTION_URL = '/employeeSalaryPromotion';
export const REGISTER_EMPLOYEE_SALARY_PROMOTION_URL = '/employeeSalaryPromotion';
export const EDIT_EMPLOYEE_SALARY_PROMOTION_URL = '/employeeSalaryPromotion';
export const TOGGLE_EMPLOYEE_SALARY_PROMOTION_IS_ACTIVE_URL = '/employeeSalaryPromotion/isActive';
export const DELETE_EMPLOYEE_SALARY_PROMOTION_URL = '/employeeSalaryPromotion';

// employee_bank
export const GET_EMPLOYEE_BANK_URL = '/employeeBank';
export const REGISTER_EMPLOYEE_BANK_URL = '/employeeBank';
export const EDIT_EMPLOYEE_BANK_URL = '/employeeBank';
export const TOGGLE_EMPLOYEE_BANK_IS_ACTIVE_URL = '/employeeBank/isActive';
export const DELETE_EMPLOYEE_BANK_URL = '/employeeBank';

// employee_education
export const GET_EMPLOYEE_EDUCATION_URL = '/employeeEducation';
export const REGISTER_EMPLOYEE_EDUCATION_URL = '/employeeEducation';
export const EDIT_EMPLOYEE_EDUCATION_URL = '/employeeEducation';
export const TOGGLE_EMPLOYEE_EDUCATION_IS_ACTIVE_URL = '/employeeEducation/isActive';
export const DELETE_EMPLOYEE_EDUCATION_URL = '/employeeEducation';

// employee_payroll
export const GET_EMPLOYEE_PAYROLL_URL = '/employeePayroll';
export const GET_EMPLOYEE_PAYROLL_STATS_URL = '/employeePayroll/stats';
export const REGISTER_EMPLOYEE_PAYROLL_URL = '/employeePayroll';
export const EDIT_EMPLOYEE_PAYROLL_URL = '/employeePayroll';
export const TOGGLE_EMPLOYEE_PAYROLL_IS_ACTIVE_URL = '/employeePayroll/isActive';
export const DELETE_EMPLOYEE_PAYROLL_URL = '/employeePayroll';

// employee_overtime
export const GET_EMPLOYEE_OVERTIME_URL = '/employeeOvertime';
export const GET_EMPLOYEE_OVERTIMES_BY_EMPLOYEE_URL = '/employeeOvertime/byEmployee';
export const REGISTER_EMPLOYEE_OVERTIME_URL = '/employeeOvertime';
export const EDIT_EMPLOYEE_OVERTIME_URL = '/employeeOvertime';
export const TOGGLE_EMPLOYEE_OVERTIME_IS_ACTIVE_URL = '/employeeOvertime/isActive';
export const DELETE_EMPLOYEE_OVERTIME_URL = '/employeeOvertime';
export const UPDATE_OVERTIME_STATUS_URL = '/employeeOvertime/status';
export const GET_OVERTIME_ANALYTICS_URL = '/employeeOvertime/analytics';
export const GET_OVERTIME_MONTH_GRID_URL = '/employeeOvertime/monthGrid';
export const EXPORT_OVERTIME_URL = '/employeeOvertime/export';

// employee_contract
export const GET_EMPLOYEE_CONTRACT_URL = '/employeeContract';
export const REGISTER_EMPLOYEE_CONTRACT_URL = '/employeeContract';
export const EDIT_EMPLOYEE_CONTRACT_URL = '/employeeContract';
export const TOGGLE_EMPLOYEE_CONTRACT_IS_ACTIVE_URL = '/employeeContract/isActive';
export const DELETE_EMPLOYEE_CONTRACT_URL = '/employeeContract';

// employee_leave
export const GET_EMPLOYEE_LEAVE_URL = '/employeeLeave';
export const REGISTER_EMPLOYEE_LEAVE_URL = '/employeeLeave';
export const EDIT_EMPLOYEE_LEAVE_URL = '/employeeLeave';
export const TOGGLE_EMPLOYEE_LEAVE_IS_ACTIVE_URL = '/employeeLeave/isActive';
export const APPROVE_EMPLOYEE_LEAVE_IS_ACTIVE_URL = '/employeeLeave/approve';
export const REJECT_EMPLOYEE_LEAVE_IS_ACTIVE_URL = '/employeeLeave/decline';
export const CANCEL_EMPLOYEE_LEAVE_IS_ACTIVE_URL = '/employeeLeave/cancel';
export const DELETE_EMPLOYEE_LEAVE_URL = '/employeeLeave';

// employee_allowance
export const GET_EMPLOYEE_ALLOWANCE_URL = '/employeeAllowance';
export const REGISTER_EMPLOYEE_ALLOWANCE_URL = '/employeeAllowance';
export const EDIT_EMPLOYEE_ALLOWANCE_URL = '/employeeAllowance';
export const TOGGLE_EMPLOYEE_ALLOWANCE_IS_ACTIVE_URL = '/employeeAllowance/isActive';
export const DELETE_EMPLOYEE_ALLOWANCE_URL = '/employeeAllowance';

// department
export const GET_DEPARTMENT_URL = '/department';
export const GET_ORGANIZATIONAL_DEPARTMENT_URL = '/department/organizational';
export const REGISTER_DEPARTMENT_URL = '/department';
export const EDIT_DEPARTMENT_URL = '/department';
export const TOGGLE_DEPARTMENT_IS_ACTIVE_URL = '/department/isActive';
export const DELETE_DEPARTMENT_URL = '/department';
export const GET_DEPARTMENT_IMPACT_URL = '/department/impact';

// position
export const GET_POSITION_URL = '/position';
export const REGISTER_POSITION_URL = '/position';
export const EDIT_POSITION_URL = '/position';
export const TOGGLE_POSITION_IS_ACTIVE_URL = '/position/isActive';
export const DELETE_POSITION_URL = '/position';
export const GET_POSITION_IMPACT_URL = '/position/impact';

// payroll
export const GET_BANK_URL = '/bank';
export const REGISTER_BANK_URL = '/bank';
export const EDIT_BANK_URL = '/bank';
export const TOGGLE_BANK_IS_ACTIVE_URL = '/bank/isActive';
export const DELETE_BANK_URL = '/bank';

// payroll_periods
export const REGISTER_PAYROLL_URL = '/payroll/register';
export const GENERATE_PAYROLL_URL = '/payroll/generate';
export const GET_PAYROLL_DETAILS_URL = '/payroll/details';
export const GET_PAYROLL_STATS_CAHRT_URL = '/payroll/stats/chart';
export const EXPORT_PAYROLL_CSV_URL = '/payroll/exportCSV';
export const EXPORT_PAYROLL_BANK_REPORT_PDF_URL = '/payroll/exportBankReportPDF';
export const EXPORT_EMPLOYEE_PAYROLL_SLIP_PDF_URL = '/payroll/exportEmployeePaySlipPDF';
export const EXPORT_EMPLOYEE_PAYROLL_ETAX_URL = '/payroll/exportETax';
export const GET_EMPLOYEES_WITHOUT_SALARY_URL = '/payroll/employeesWithoutSalary';
export const GET_EMPLOYEES_WITH_SALARY_URL = '/payroll/employeesWithSalary';
export const GET_PAYROLL_COMPENSATION_URL = '/payroll/compensation';
export const GET_PAYROLL_ANALYTICS_URL = '/payroll/analytics';
export const GET_PAYROLL_EMPLOYEE_ANALYTICS_URL = '/payroll/analytics/employee';
export const EXPORT_PAYROLL_REPORT_URL = '/payroll/analytics/export';
export const APPROVE_PAYROLL_URL = '/payroll/approve';
export const EDIT_PAYROLL_URL = '/payroll';
export const TOGGLE_PAYROLL_IS_ACTIVE_URL = '/payroll/isActive';
export const DELETE_PAYROLL_URL = '/payroll';

// payroll
export const GET_PAYROLL_PERIOD_URL = '/payrollPeriod';
export const REGISTER_PAYROLL_PERIOD_URL = '/payrollPeriod';
export const EDIT_PAYROLL_PERIOD_URL = '/payrollPeriod';
export const TOGGLE_PAYROLL_PERIOD_IS_ACTIVE_URL = '/payrollPeriod/isActive';
export const DELETE_PAYROLL_PERIOD_URL = '/payrollPeriod';

// leave_type
export const GET_LEAVE_TYPE_URL = '/leaveType';
export const REGISTER_LEAVE_TYPE_URL = '/leaveType';
export const EDIT_LEAVE_TYPE_URL = '/leaveType';
export const TOGGLE_LEAVE_TYPE_IS_ACTIVE_URL = '/leaveType/isActive';
export const DELETE_LEAVE_TYPE_URL = '/leaveType';

// leave_request
export const GET_LEAVE_REQUEST_URL = '/leaveRequest';
export const GET_LEAVE_REQUEST_STATS_URL = '/leaveRequest/stats';
export const REGISTER_LEAVE_REQUEST_URL = '/leaveRequest';
export const APPROVE_LEAVE_REQUEST_URL = '/leaveRequest/approve';
export const REJECT_LEAVE_REQUEST_URL = '/leaveRequest/reject';
export const CANCEL_LEAVE_REQUEST_URL = '/leaveRequest/cancel';
export const EDIT_LEAVE_REQUEST_URL = '/leaveRequest';
export const TOGGLE_LEAVE_REQUEST_IS_ACTIVE_URL = '/leaveRequest/isActive';
export const DELETE_LEAVE_REQUEST_URL = '/leaveRequest';

// leave_balance
export const GET_LEAVE_BALANCE_URL = '/leaveBalance';
export const REGISTER_LEAVE_BALANCE_URL = '/leaveBalance';
export const EDIT_LEAVE_BALANCE_URL = '/leaveBalance/manual';
export const TOGGLE_LEAVE_BALANCE_IS_ACTIVE_URL = '/leaveBalance';
export const DELETE_LEAVE_BALANCE_URL = '/leaveBalance';

// leave_ledger
export const GET_LEAVE_LEDGER_URL = '/leaveLedger';
export const GET_LEAVE_LEDGERS_URL = '/leaveLedger';
export const REGISTER_LEAVE_LEDGER_URL = '/leaveLedger';
export const EDIT_LEAVE_LEDGER_URL = '/leaveLedger';
export const DELETE_LEAVE_LEDGER_URL = '/leaveLedger';

// holiday
export const GET_CALENDAR_HOLIDAY_URL = '/holiday/layout/calendar';
export const GET_HOLIDAY_URL = '/holiday/layout/list';
export const CHECK_HOLIDAY_URL = '/holiday/isHoliday';
export const REGISTER_CALENDAR_HOLIDAY_URL = '/holiday';
export const REMOVE_HOLIDAY_URL = '/holiday/remove';

// overtime_setting
export const GET_OVERTIME_SETTING_URL = '/overtimeSetting';
export const CHECK_OVERTIME_SETTING_URL = '/overtimeSetting/isUsed';
export const REGISTER_OVERTIME_SETTING_URL = '/overtimeSetting';
export const EDIT_OVERTIME_SETTING_URL = '/overtimeSetting';
export const TOGGLE_OVERTIME_SETTING_IS_ACTIVE_URL = '/overtimeSetting/isActive';
export const DELETE_OVERTIME_SETTING_URL = '/overtimeSetting';

// allowance_type
export const GET_ALLOWANCE_TYPE_URL = '/allowanceType';
export const REGISTER_ALLOWANCE_TYPE_URL = '/allowanceType';
export const EDIT_ALLOWANCE_TYPE_URL = '/allowanceType';
export const TOGGLE_ALLOWANCE_TYPE_IS_ACTIVE_URL = '/allowanceType/isActive';
export const DELETE_ALLOWANCE_TYPE_URL = '/allowanceType';

// attendance_logs
export const REGISTER_ATTENDANCE_LOG_URL = '/attendanceLog';
export const GET_ATTENDANCE_LOG_URL = '/attendanceLog';
export const GET_EMPLOYEE_ATTENDANCE_LOG_URL = '/attendanceLog/byEmployee';
export const GET_EMPLOYEE_ATTENDANCE_DAY_URL = '/attendanceLog/employeeLogDays';
export const GET_CALENDAR_ATTENDANCE_LOG_URL = '/attendanceLog/calendar';
export const GET_ATTENDANCE_REPORT_URL = '/attendanceLog/report';
export const GET_ATTENDANCE_ANALYTICS_URL = '/attendanceLog/analytics';
export const GET_ATTENDANCE_DAY_RECORDS_URL = '/attendanceLog/analytics/days';
export const EXPORT_ATTENDANCE_URL = '/attendanceLog/analytics/export';

// attendance_schedule
export const GET_ATTENDANCE_SCHEDULE_URL = '/attendanceSchedule';
export const REGISTER_ATTENDANCE_SCHEDULE_URL = '/attendanceSchedule';
export const EDIT_ATTENDANCE_SCHEDULE_URL = '/attendanceSchedule';
export const TOGGLE_ATTENDANCE_SCHEDULE_IS_ACTIVE_URL = '/attendanceSchedule/isActive';
export const DELETE_ATTENDANCE_SCHEDULE_URL = '/attendanceSchedule'

// attendance_shift
export const GET_ATTENDANCE_SHIFT_URL = '/attendanceShift';
export const REGISTER_ATTENDANCE_SHIFT_URL = '/attendanceShift';
export const EDIT_ATTENDANCE_SHIFT_URL = '/attendanceShift';
export const TOGGLE_ATTENDANCE_SHIFT_IS_ACTIVE_URL = '/attendanceShift/isActive';
export const DELETE_ATTENDANCE_SHIFT_URL = '/attendanceShift'

// employee_attendance_shift
export const GET_EMPLOYEE_ATTENDANCE_SHIFT_URL = '/employeeAttendanceShift';
export const REGISTER_EMPLOYEE_ATTENDANCE_SHIFT_URL = '/employeeAttendanceShift';
export const EDIT_EMPLOYEE_ATTENDANCE_SHIFT_URL = '/employeeAttendanceShift';
export const TOGGLE_EMPLOYEE_ATTENDANCE_SHIFT_IS_ACTIVE_URL = '/employeeAttendanceShift/isActive';
export const DELETE_EMPLOYEE_ATTENDANCE_SHIFT_URL = '/employeeAttendanceShift'

// file
export const GET_FILE_URL = '/file';
export const REGISTER_FILE_URL = '/file';
export const EDIT_FILE_URL = '/file';
export const TOGGLE_FILE_IS_ACTIVE_URL = '/file/isActive';
export const DELETE_FILE_URL = '/file';

// payroll_component
export const GET_PAYROLL_COMPONENT_URL = '/payrollComponent';
export const REGISTER_PAYROLL_COMPONENT_URL = '/payrollComponent';
export const EDIT_PAYROLL_COMPONENT_URL = '/payrollComponent';
export const TOGGLE_PAYROLL_COMPONENT_IS_ACTIVE_URL = '/payrollComponent/isActive';
export const DELETE_PAYROLL_COMPONENT_URL = '/payrollComponent';

// employee_payroll_component
export const GET_EMPLOYEE_PAYROLL_COMPONENT_URL = '/employeePayrollComponent';
export const REGISTER_EMPLOYEE_PAYROLL_COMPONENT_URL = '/employeePayrollComponent';
export const EDIT_EMPLOYEE_PAYROLL_COMPONENT_URL = '/employeePayrollComponent';
export const TOGGLE_EMPLOYEE_PAYROLL_COMPONENT_IS_ACTIVE_URL = '/employeePayrollComponent/isActive';
export const DELETE_EMPLOYEE_PAYROLL_COMPONENT_URL = '/employeePayrollComponent';

// stats
export const GET_DASHBOARD_STATS_URL = '/stats/dashboard';
export const GET_EMPLOYEE_DASHBOARD_STATS_URL = '/stats/dashboard/employee';
export const GET_ADMIN_DASHBOARD_STATS_URL = '/stats/dashboard/admin';

// guideline
export const GET_GUIDELINE_URL = '/guideline';
export const REGISTER_GUIDELINE_URL = '/guideline';
export const EDIT_GUIDELINE_URL = '/guideline';
export const TOGGLE_GUIDELINE_IS_ACTIVE_URL = '/guideline/isActive';
export const DELETE_GUIDELINE_URL = '/guideline';

// job_application
export const GET_JOB_APPLICATION_URL = '/jobApplication';
export const REGISTER_JOB_APPLICATION_URL = '/jobApplication';
export const EDIT_JOB_APPLICATION_URL = '/jobApplication';
export const TOGGLE_JOB_APPLICATION_IS_ACTIVE_URL = '/jobApplication/isActive';
export const UPDATE_JOB_APPLICATION_STATUS_URL = '/jobApplication/status';
export const GET_JOB_APPLICATION_STATS_URL = '/jobApplication/stats';
export const DELETE_JOB_APPLICATION_URL = '/jobApplication';

// job_post
export const GET_JOB_POST_URL = '/jobPost';
export const REGISTER_JOB_POST_URL = '/jobPost';
export const EDIT_JOB_POST_URL = '/jobPost';
export const TOGGLE_JOB_POST_IS_ACTIVE_URL = '/jobPost/isActive';
export const DELETE_JOB_POST_URL = '/jobPost';

// project
export const GET_PROJECT_URL = '/project';
export const REGISTER_PROJECT_URL = '/project';
export const EDIT_PROJECT_URL = '/project';
export const TOGGLE_PROJECT_IS_ACTIVE_URL = '/project/isActive';
export const DELETE_PROJECT_URL = '/project';

// client
export const GET_CLIENT_URL = '/client';
export const REGISTER_CLIENT_URL = '/client';
export const EDIT_CLIENT_URL = '/client';
export const TOGGLE_CLIENT_IS_ACTIVE_URL = '/client/isActive';
export const DELETE_CLIENT_URL = '/client';

// billing_invoicing
export const GET_BILLING_AND_INVOICING_URL = '/billingAndInvoicing';
export const REGISTER_BILLING_AND_INVOICING_URL = '/billingAndInvoicing';
export const EDIT_BILLING_AND_INVOICING_URL = '/billingAndInvoicing';
export const TOGGLE_BILLING_AND_INVOICING_IS_ACTIVE_URL = '/billingAndInvoicing/isActive';
export const GET_BILLING_AND_INVOICING_STATS_URL = '/billingAndInvoicing/stats';
export const DELETE_BILLING_AND_INVOICING_URL = '/billingAndInvoicing';
export const DOWNLOAD_INVOICE_PDF_URL = '/billingAndInvoicing';

// invoice_item
export const GET_INVOICE_ITEM_URL = '/invoiceItem';
export const REGISTER_INVOICE_ITEM_URL = '/invoiceItem';
export const EDIT_INVOICE_ITEM_URL = '/invoiceItem';
export const TOGGLE_INVOICE_ITEM_IS_ACTIVE_URL = '/invoiceItem/isActive';
export const DELETE_INVOICE_ITEM_URL = '/invoiceItem';

// project_milestone
export const GET_MILESTONE_URL = '/projectMilestone';
export const REGISTER_MILESTONE_URL = '/projectMilestone';
export const EDIT_MILESTONE_URL = '/projectMilestone';
export const TOGGLE_MILESTONE_IS_ACTIVE_URL = '/projectMilestone/isActive';
export const DELETE_MILESTONE_URL = '/projectMilestone';

// project_employee
export const GET_PROJECT_EMPLOYEE_URL = '/projectEmployee';
export const REGISTER_PROJECT_EMPLOYEE_URL = '/projectEmployee';
export const EDIT_PROJECT_EMPLOYEE_URL = '/projectEmployee';
export const TOGGLE_PROJECT_EMPLOYEE_IS_ACTIVE_URL = '/projectEmployee/isActive';
export const DELETE_PROJECT_EMPLOYEE_URL = '/projectEmployee';

// project_transaction
export const GET_PROJECT_TRANSACTION_URL = '/projectTransaction';
export const GET_PROJECT_TRANSACTION_STATS_URL = '/projectTransaction/stats';
export const REGISTER_PROJECT_TRANSACTION_URL = '/projectTransaction';
export const EDIT_PROJECT_TRANSACTION_URL = '/projectTransaction';
export const TOGGLE_PROJECT_TRANSACTION_IS_ACTIVE_URL = '/projectTransaction/isActive';
export const DELETE_PROJECT_TRANSACTION_URL = '/projectTransaction';

// project_file
export const GET_PROJECT_FILE_URL = '/projectFile';
export const REGISTER_PROJECT_FILE_URL = '/projectFile';
export const EDIT_PROJECT_FILE_URL = '/projectFile';
export const TOGGLE_PROJECT_FILE_IS_ACTIVE_URL = '/projectFile/isActive';
export const DELETE_PROJECT_FILE_URL = '/projectFile';

// project_employee_role
export const GET_PROJECT_EMPLOYEE_ROLE_URL = '/projectEmployeeRole';
export const REGISTER_PROJECT_EMPLOYEE_ROLE_URL = '/projectEmployeeRole';
export const EDIT_PROJECT_EMPLOYEE_ROLE_URL = '/projectEmployeeRole';
export const TOGGLE_PROJECT_EMPLOYEE_ROLE_IS_ACTIVE_URL = '/projectEmployeeRole/isActive';
export const DELETE_PROJECT_EMPLOYEE_ROLE_URL = '/projectEmployeeRole';

// employee_offboarding_template
export const GET_EMPLOYEE_OFFBOARDING_TEMPLATE_URL = '/employeeOffboardingTemplate';
export const REGISTER_EMPLOYEE_OFFBOARDING_TEMPLATE_URL = '/employeeOffboardingTemplate';
export const EDIT_EMPLOYEE_OFFBOARDING_TEMPLATE_URL = '/employeeOffboardingTemplate';
export const DELETE_EMPLOYEE_OFFBOARDING_TEMPLATE_URL = '/employeeOffboardingTemplate';

// employee_offboarding
export const GET_EMPLOYEE_OFFBOARDING_URL = '/employeeOffboarding';
export const REGISTER_EMPLOYEE_OFFBOARDING_URL = '/employeeOffboarding';
export const EDIT_EMPLOYEE_OFFBOARDING_URL = '/employeeOffboarding';
export const DELETE_EMPLOYEE_OFFBOARDING_URL = '/employeeOffboarding';

// employee_offboarding_checklist
export const TOGGLE_EMPLOYEE_OFFBOARDING_CHECKLIST_STATUS_URL = '/employeeOffboardingChecklist/status';

// knowledge_base_category
export const GET_KNOWLEDGE_BASE_CATEGORY_URL = '/knowledgeBaseCategory';
export const REGISTER_KNOWLEDGE_BASE_CATEGORY_URL = '/knowledgeBaseCategory';
export const EDIT_KNOWLEDGE_BASE_CATEGORY_URL = '/knowledgeBaseCategory';
export const DELETE_KNOWLEDGE_BASE_CATEGORY_URL = '/knowledgeBaseCategory';

// knowledge_base_article
export const GET_KNOWLEDGE_BASE_ARTICLE_URL = '/knowledgeBaseArticle';
export const REGISTER_KNOWLEDGE_BASE_ARTICLE_URL = '/knowledgeBaseArticle';
export const EDIT_KNOWLEDGE_BASE_ARTICLE_URL = '/knowledgeBaseArticle';
export const DELETE_KNOWLEDGE_BASE_ARTICLE_URL = '/knowledgeBaseArticle';

// reports
export const GET_EMPLOYEE_REPORTS_URL = '/reports/employee';
export const GET_PAYROLL_REPORTS_URL = '/reports/payroll';
export const GET_PROJECT_REPORTS_URL = '/reports/project';
export const GET_REPORT_FACETS_URL = '/reports/facets';
export const GENERATE_REPORT_URL = '/reports/generate';

// export_template
export const GET_EXPORT_TEMPLATE_URL = '/exportTemplate';
export const REGISTER_EXPORT_TEMPLATE_URL = '/exportTemplate';
export const EDIT_EXPORT_TEMPLATE_URL = '/exportTemplate';
export const DELETE_EXPORT_TEMPLATE_URL = '/exportTemplate';
/** POST `${DUPLICATE_EXPORT_TEMPLATE_URL}/:id/duplicate` */
export const DUPLICATE_EXPORT_TEMPLATE_URL = '/exportTemplate';
export const GET_EXPORT_DATASETS_URL = '/exportTemplate/datasets';
/** GET `${GET_EXPORT_DATASET_FIELDS_URL}/:key/fields` */
export const GET_EXPORT_DATASET_FIELDS_URL = '/exportTemplate/datasets';
export const RUN_EXPORT_TEMPLATE_URL = '/exportTemplate/run';
export const GENERATE_EXPORT_TEMPLATE_URL = '/exportTemplate/generate';

// chat
export const GET_CHAT_DIRECTORY_URL = '/chat/directory';
export const GET_CHAT_UNREAD_URL = '/chat/unread';
export const GET_CHAT_CONVERSATIONS_URL = '/chat/conversations';
export const CREATE_CHAT_DIRECT_URL = '/chat/conversations/direct';
export const CREATE_CHAT_GROUP_URL = '/chat/conversations/group';
/** `${CHAT_CONVERSATION_URL}/:id` plus `/members`, `/leave`, `/mute`, `/read`, `/messages`, `/files` */
export const CHAT_CONVERSATION_URL = '/chat/conversations';
export const PRESIGN_CHAT_UPLOAD_URL = '/chat/uploads/presign';
export const DISCARD_CHAT_UPLOAD_URL = '/chat/uploads';
export const GET_CHAT_NOTIFICATIONS_URL = '/chat/notifications';
export const MARK_CHAT_NOTIFICATIONS_SEEN_URL = '/chat/notifications/seen';
export const MARK_CHAT_NOTIFICATIONS_READ_URL = '/chat/notifications/read';

// files (the Files module)
export const GET_DRIVE_TREE_URL = '/drive/tree';
export const BROWSE_DRIVE_URL = '/drive/browse';
export const GET_DRIVE_USAGE_URL = '/drive/usage';
/** `${DRIVE_FOLDERS_URL}/:id` for update and delete */
export const DRIVE_FOLDERS_URL = '/drive/folders';
/** `${DRIVE_UPLOADS_URL}/:id/complete` and `DELETE ${DRIVE_UPLOADS_URL}/:id` */
export const DRIVE_UPLOADS_URL = '/drive/uploads';
/** `${DRIVE_FILES_URL}/:id` for update and delete, `/:id/download` for a link */
export const DRIVE_FILES_URL = '/drive/files';
